/**
 * A fully-keyed empty mailbox object for the embedded SmtpCredentials form.
 *
 * WHY every field must be present up front: SmtpCredentials binds each field via a
 * computed getter (`_.get(cms[scope], 'address')`, …). In Vue 2, a computed that reads
 * a property which does NOT yet exist never subscribes to it, so a later `Vue.set` of
 * that key does not invalidate the computed — the input renders the typed value back as
 * empty ("frozen fields"). A mailbox loaded from the server already has all keys, so it
 * works; a freshly-created one (e.g. re-adding a POS mailbox after deleting it) is an
 * empty `{}` and freezes. Seeding every key the form reads/writes keeps the whole form
 * reactive from first render.
 *
 * Keep this in sync with the getters/setters in
 * `src/views/settings/Account/Form/Partials/SmtpCredentials.vue`. Values mirror each
 * getter's fallback, so a seeded mailbox behaves identically to the old empty `{}`.
 */
export default function emptyMailbox() {
    return {
        id: null,
        address: '',
        name: '',
        auth_method: 'password',
        host: '',
        port: '',
        username: '',
        password: '',
        mailgun_webhook_signing_key: '',
        imap_enabled: false,
        imap_host: '',
        imap_port: '',
        imap_username: '',
        imap_encryption: '',
        imap_password: '',
        has_dedicated_imap_password: false,
        validation_status: null,
        imap_validation_status: null,
        is_oauth_connected: false,
        oauth_pending_token: null,
    }
}
